<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>

    <b-card>
      <b-row
        ><b-col
          ><h3>Trade {{ $route.params.id }}</h3></b-col
        ></b-row
      >
      <b-row>
        <b-col>
          <!-- TRADE DETAILS -->
          <collapsable
            class="collapsable"
            ref="tradeDetails"
            content="trade details"
            :visible="true"
          >
            <TradeDetails
              :swapId="$route.params.id"
              @ready="ready"
            ></TradeDetails>
          </collapsable> </b-col
      ></b-row>

      <div v-if="loading">
        <b-spinner label="Spinning"></b-spinner>
      </div>
      <div v-else>
        <!-- NPV and cashflow calculation -->
        <collapsable content="Pricing" :visible="true">
          <b-btn @click="price" variant="success">Price the trade</b-btn>
          <div v-if="pricingLoaded">
            <b-row class="mt-2">
              <b-col>
                <b-table striped hover :items="pricing.pv"> </b-table>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <b-table striped hover :items="pricing.cashflows"> </b-table>
              </b-col>
            </b-row>
          </div>
        </collapsable>
      </div>
    </b-card>
  </div>
</template>

<script>
import moment from "moment";
import TradeDetails from "@/components/TradeDetails.vue";
export default {
  data() {
    return {
      items: [
        {
          text: "portfolio",
          to: { name: "portfolio" }
        },
        {
          text: this.$route.params.id,
          active: true
        }
      ],
      loading: true,
      // This is used to send back to the server.
      tradeData: {
        rate: 0.0,
        startDate: "",
        endDate: "",
        index: "",
        direction: "",
        notional: "",
        currency: ""
      },

      pricing: { pv: [], cashflows: [] },
      pricingLoaded: false
    };
  },
  methods: {
    ready(payLeg, recLeg) {
      this.tradeData.startDate = payLeg.accrualSchedule.startDate;
      this.tradeData.endDate = payLeg.accrualSchedule.endDate;

      this.tradeData.notional = payLeg.notionalSchedule.amount;
      this.tradeData.currency = payLeg.notionalSchedule.currency;
      // Buy means receive the Floating leg. Sell means pay the floating leg.
      if (payLeg.calculation.index !== undefined) {
        this.tradeData.direction = "SELL";
        this.tradeData.index = payLeg.calculation.index;
        this.tradeData.rate = recLeg.calculation.rate;
      } else {
        this.tradeData.direction = "BUY";
        this.tradeData.index = recLeg.calculation.index;
        this.tradeData.rate = payLeg.calculation.rate;
      }
      this.loading = false;
    },
    async price() {
      let pricing = await this.$client.priceTrade(this.tradeData);
      this.pricing.pv = pricing.pv;
      this.pricing.cashflows = pricing.cashflows.map(cashflow => {
        var c = {
          cashflowDate: moment({
            y: cashflow.cashflowDate.year,
            M: cashflow.cashflowDate.monthValue,
            d: cashflow.cashflowDate.dayOfMonth
          }),
          presentValue: `${cashflow.presentValue.currency} ${cashflow.presentValue.amount}`,
          forecastValue: `${cashflow.forecastValue.currency} ${cashflow.forecastValue.amount}`,
          discountFactor: cashflow.discountFactor
        };

        return c;
      });
      this.pricingLoaded = true;
    }
  },
  components: { TradeDetails }
};
</script>
